import { IsInt, IsString, MinLength } from 'class-validator';

export class PasswordLoginDto {
  @IsInt()
  userNameOrMobile!: number;

  @IsString()
  @MinLength(8)
  password!: string;
}
